var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"id":"main","element-loading-text":_vm.loadingText}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }